'use strict';

// jQuery global
window.$ = require('jquery');
window.jQuery = window.$;

// Gallery slider
require('owl.carousel');
require('owl.carousel2.thumbs');

// Site modules
require('./modules/menu');
require('./modules/google-maps');
require('./modules/google-analytics');
require('./modules/slider');



//////////////////
// WEBPACK FOOTER
// ./src/httpdocs/root/static/js/scripts.js
// module id = 0
// module chunks = 0